import { render, staticRenderFns } from "./LocaleMessagePicker.vue?vue&type=template&id=019e8579&scoped=true&"
import script from "./LocaleMessagePicker.vue?vue&type=script&lang=js&"
export * from "./LocaleMessagePicker.vue?vue&type=script&lang=js&"
import style0 from "./LocaleMessagePicker.vue?vue&type=style&index=0&id=019e8579&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e8579",
  null
  
)

export default component.exports